import { render, staticRenderFns } from "./RoomConfigurator_comp.vue?vue&type=template&id=5faae3fb&scoped=true&"
import script from "./RoomConfigurator_comp.vue?vue&type=script&lang=js&"
export * from "./RoomConfigurator_comp.vue?vue&type=script&lang=js&"
import style0 from "./RoomConfigurator_comp.vue?vue&type=style&index=0&id=5faae3fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faae3fb",
  null
  
)

export default component.exports